import { Navigate, Outlet, useLocation } from 'react-router';
import { AUTH_ACTION_PATH, GATE_PATHS, useSiteMode } from './siteModeContext';

const gatePaths: string[] = Object.values(GATE_PATHS);

/**
 * Root route (D32). While the site is gated, every path goes to that mode's page, and nobody
 * bypasses it. The one exception is the auth email handler, which only acts on a one-time code
 * from the email and links nowhere but sign-in (D34). Once live, the gate pages send people home.
 */
export function SiteGate() {
  const { config } = useSiteMode();
  const { pathname } = useLocation();

  if (config.mode === 'live') {
    return gatePaths.includes(pathname) ? <Navigate to="/" replace /> : <Outlet />;
  }
  if (pathname === AUTH_ACTION_PATH) return <Outlet />;
  const target = GATE_PATHS[config.mode];
  return pathname === target ? <Outlet /> : <Navigate to={target} replace />;
}
